import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { Severity ,ObjectNames } from 'src/app/inventory/constants/constants';
import { PurchasesService } from 'src/app/inventory/purchases/purchases.service';
import { UtilsService } from 'src/app/inventory/purchases/utility/utils.service';
import { TypeGroupIds } from '../../constants/category-groupid.constants';
import { addInList } from '../../helpers';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { PaymentmethodService } from 'src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service';
import { PaymenttermService } from 'src/app/configurations/inventory/setup/paymentterm/paymentterm.service';
import { ShippingmethodService } from 'src/app/configurations/inventory/setup/shippingmethod/shippingmethod.service';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { forkJoin } from 'rxjs';
import { CompanyBranchService } from 'src/app/configurations/company-branch/company-branch.service';


@Component({
  selector: 'app-vendor-view-edit',
  templateUrl: './vendor-view-edit.component.html',
  styleUrls: ['./vendor-view-edit.component.scss']
})
export class VendorViewEditComponent implements OnInit, OnChanges {

  vendorTemplate;
  allPaymentTerms = [];
  allPaymentMethods = [];
  allPurchaseTemplates: any[] = [];
  purchaseConfigs: any[] = [];
  purchaseChannels: any[] = [];
  selectedChannel: any = {};
  allStages: any[] = [];
  allShippingMethods: any[] = [];
  @Input()  selectedVendor :any 
  allPaymentTermsDD = [];
  allPaymentMethodsDD = [];
  allShippingMethodDD = [];
  //
  allShippingMethodDropdown = [];
  customFields = [];
  vendorEmailTypes = [];
  vendorPhoneTypes = [];
  contactEmailTypes = [];
  contactPhoneTypes = [];
  contactSocialTypes = [];
  genders = [];
  jobFunctions = [];
  languages = [];
  associationTypes = [];
  salutations = [];
  //
  @Output() closeDialog = new EventEmitter<boolean>();
  isAddVendor: boolean = true;
  socialProfileTypes = [];
  vendorTempAddress = [];
  emailTypes = [];
  phoneTypes = [];
  addressTypes = [];
  reportsTo = [];

  assistant = [];
  ErrorMessageSetLocation: string = '';
  displayVendorAdd = false;
  showAccountInfoMore: boolean = false;
  displayAddressAdd: boolean = false;
  vendorHeader: string = '';
  addressHeader: string = '';
  addressForm: FormGroup;
  vendorForm: FormGroup;
  allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files
  savedVendor;
  vendorTypes = [];
  annualRevenue = [];
  industryList = [];
  owners = [];
  employeesCount = [];
  businessClass = [];
  categories = [];
  selectedCategory;
  timeZoneList = [];
  selectedTimezone;
  currencyList = [];
  city = [];
  states = [];
  country = [];
  maxDate: Date = new Date();
  vendor_information = [];
  vendor_contact = [];
  vendor_address = [];
  vendor_business = [];
  vendor_payment = [];
  vendor_other1 = [];
  vendor_other2 = [];
  vendor_other3 = [];
  selectedCurrency;
  myAddressPageNo = 0;
  isSameAsMaillingAddress: boolean = false;
  isView: boolean = false;
  isDisabled: boolean = false;
  applyValidation: boolean = false;
  purchaseObjId;
  editAddressIndex = null;
  displayAddAddressType: boolean = false;
  addressTypeForm: FormGroup;
  lattitude = 0;
  longitude = 0;
  addressInput: string = '';
  filteredContact = [];
  selectedShippingTerms = [];
  vendorPayemntTermRule;
  vendorPayemntMethodRule;

  poTemplate;
  configCustomFields: any[] = [];
  purchase_billing: any[] = [];
  purchase_shipping: any[] = [];
  purchase_misc: any[] = [];
  purchase_section: any[] = [];
  purchase_table: any[] = [];
  purchase_footer: any[] = [];
  purchase_message: any[] = [];
  purchase_other1: any[] = [];
  purchase_other2: any[] = [];
  purchase_other3: any[] = [];

  constructor(private purchaseService: PurchasesService, private fb: FormBuilder, private app: AppMainComponent,
    private datepipe: DatePipe, public confirmationService: ConfirmationService, private titlecasePipe: TitleCasePipe,
    private messageService: MessageService, private appMainService: AppMainService,public utility: UtilsService,
    private paymentMethodService: PaymentmethodService,private paymentTermService: PaymenttermService,
    private shippingMethodService: ShippingmethodService,private productsService: ProductsService,private companyBranchService: CompanyBranchService) { }

  ngOnChanges() {
    this.vendorForms();
    this.fetchData();
  }

  ngOnInit(): void {
    this.purchaseObjId = this.app.preLoadedObjects.find(
      (el) => el.name == ObjectNames.purchaseConstants.Purchase_Module_Object)?.id;
    this.vendorForm = this.fb.group({
      id: [0],
      vendorName: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      vendorTypeId: ['', [Validators.required]],
      accountNumber: [''],
      title: [''],
      salutationId: [''],
      firstName: [''],
      lastName: [''],
      middleName: [''],
      contactEmail: ['', [Validators.pattern(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/)]],
      contactPhone: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      extension: [null],
      socialProfile: [''],
      doingBusinessAs: [''],
      taxId: [''],
      businessClassificationId: [''],
      sicCode: [''],
      naicsCode: [''],
      industryId: [''],
      foundedYear: [''],
      ownershipId: [''],
      employeesRangeId: [''],
      annualRevenueId: [''],
      paymentTermId: [''],
      preferredPaymentTermId: [''],
      paymentMethodId: [''],
      preferredPaymentMethodId: [''],
      shippingMethodId: [''],
      preferredShippingMethodId: [''],
      phoneNumber: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      emailAddress: ['', [Validators.pattern(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/)]],
      statusId: [true],
      isPrimaryContact: [true],
      timeZoneId: [''],
      currencyId: [''],
      genderId: [''],
      dob: [null],
      languages: [''],
      job: [''],
      assistantId: [''],
      assistantPhone: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      reportsToId: [''],
      customAttributeValues: ['']
    })
    this.addressForm = this.fb.group({
      id: [0],
      addressType: ['', [Validators.required]],
      address: [''],
      addressId: [0],
      formattedAddress: [''],
      streetAddress2: [''],
      lattitude: [''],
      longitude: [''],
      countryId: [''],
      stateId: [''],
      cityId: [''],
      zipCode: [''],
      attentionId: [''],
      statusId: [true],
      isDefault: [false]
    })
    this.addressTypeForm = this.fb.group({
      id: [0],
      createdSource: [this.app.user.userIP],
      updatedSource: [this.app.user.userIP],
      createdBy: [this.app.user.userId],
      updatedBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      parentTypeId: [0],
      description: [''],
      groupId: TypeGroupIds.AddressTypeCoreAPI,
      organizationId: [this.app.user.organizationId],
      colorCodeId: [0],
      statusId: [true]
    })
    this.getAllGroup()
    this.loadTimezones();
    this.loadAnnualIncome();
    this.loadOwners();
    this.loadIndustry();
    this.loadEmployeesCount();
    this.loadCurrency();
    this.getAllCountry();
    this.getAllAddressTypes();
    //this.loadAssistant();
    this.loadCustomRules();
    this.getPOSettings('Purchase');
    this.fetchData();
  }

  vendorForms(){
    this.vendorForm = this.fb.group({
      id: [0],
      vendorName: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      vendorTypeId: ['', [Validators.required]],
      accountNumber: [''],
      title: [''],
      salutationId: [''],
      firstName: [''],
      lastName: [''],
      middleName: [''],
      contactEmail: ['', [Validators.pattern(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/)]],
      contactPhone: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      extension: [null],
      socialProfile: [''],
      doingBusinessAs: [''],
      taxId: [''],
      businessClassificationId: [''],
      sicCode: [''],
      naicsCode: [''],
      industryId: [''],
      foundedYear: [''],
      ownershipId: [''],
      employeesRangeId: [''],
      annualRevenueId: [''],
      paymentTermId: [''],
      preferredPaymentTermId: [''],
      paymentMethodId: [''],
      preferredPaymentMethodId: [''],
      shippingMethodId: [''],
      preferredShippingMethodId: [''],
      phoneNumber: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      emailAddress: ['', [Validators.pattern(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/)]],
      statusId: [true],
      isPrimaryContact: [true],
      timeZoneId: [''],
      currencyId: [''],
      genderId: [''],
      dob: [null],
      languages: [''],
      job: [''],
      assistantId: [''],
      assistantPhone: [null, [Validators.pattern(/^[ 0-9_@()./#&+-]*$/)]],
      reportsToId: [''],
      customAttributeValues: ['']
    })
  }

  fetchData() {
    this.appMainService.isShowSpinner("loadData");
    forkJoin({
      paymentTerms: this.paymentTermService.getPaymentTermList(2,true),
      shippingMethods: this.shippingMethodService.getShippingMethodList(),
      paymentMethods: this.paymentMethodService.getPaymentMrthodList(3,true),
      salutations: this.purchaseService.getSalutations(),
      genders: this.purchaseService.getGender(),
      jobFunctions: this.purchaseService.getContactRoles(),
      languages: this.purchaseService.getLanguage(),
      associationTypes: this.purchaseService.getContactAssociationTypes() 
    }).subscribe({
      next: (results) => {
      this.appMainService.isHideSpinner("loadData");
        const { paymentTerms, shippingMethods, paymentMethods, salutations, genders, jobFunctions, languages, associationTypes } = results;
        //payment terms
        paymentTerms.forEach(term => {
          term.inactive = (term.statusId === 1 ? false : true);
        });
        this.allPaymentTerms = paymentTerms;
        // shipping methods
        this.allShippingMethods = shippingMethods;
        // payment methods
        paymentMethods.forEach(method => {
          method.inactive = (method.statusId === 1 ? false : true);
        });
        this.allPaymentMethods = paymentMethods;
        this.allShippingMethodDropdown = [...shippingMethods];
        this.salutations = salutations;
        this.genders = genders;
        this.jobFunctions = jobFunctions;
        this.languages = languages;
        this.associationTypes = associationTypes; 
  
      },
      error: (err) => {
       this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });
  }



  getPOSettings(name, type?) {
    this.appMainService.isShowSpinner("loadData");
    this.purchaseService.getPOConfigurations(name)
    .subscribe((configs) => {
      this.appMainService.isHideSpinner("loadData");
      this.purchaseConfigs = configs;
      if (!type) {
        const purchaseChannel = configs.filter(config => config.name == 'Purchase Type')[0];
        if (purchaseChannel?.configurationDetails.length > 0) {
          this.purchaseChannels = JSON.parse(purchaseChannel?.configurationDetails[0].configJSONValue);
          this.selectedChannel = this.purchaseChannels.filter(ch => ch.isDefault)[0];
          this.allStages = this.selectedChannel.stages;
        }

        const purchaseTemplate = configs.filter(config => config.name == 'Purchase Template')[0];
        this.poTemplate = this.allPurchaseTemplates?.filter((t) => t.producttypeId == this.selectedChannel.id)[0];
        
        this.selectedChannel = this.purchaseChannels?.filter(
          (channel: any) => channel.name == 'Vendors'
        )[0];

        if (purchaseTemplate?.configurationDetails.length > 0) {
          this.allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
              this.vendorTemplate = this.allPurchaseTemplates?.filter((t) => t.producttypeId == this.selectedChannel.id)[0];
        }
        
      }


      const vendorEmailType = configs.filter(config => config.name == 'Purchase Email Types')[0];
      if (vendorEmailType?.configurationDetails.length > 0) {
        this.vendorEmailTypes = JSON.parse(
          vendorEmailType?.configurationDetails[0].configJSONValue
        );
      }
      const vendorPhoneType = configs.filter(config => config.name == 'Purchase Phone Types')[0];
      if (vendorPhoneType?.configurationDetails.length > 0) {
        this.vendorPhoneTypes = JSON.parse(
          vendorPhoneType?.configurationDetails[0].configJSONValue
        );
      }
      const contactPhoneType = configs.filter(config => config.name == 'Contacts Phone Types')[0];
      if (contactPhoneType?.configurationDetails.length > 0) {
        this.contactPhoneTypes = JSON.parse(
          contactPhoneType?.configurationDetails[0].configJSONValue
        );
      }
      const contactEmailType = configs.filter(config => config.name == 'Contacts Email Types')[0];
      if (contactEmailType?.configurationDetails.length > 0) {
        this.contactEmailTypes = JSON.parse(
          contactEmailType?.configurationDetails[0].configJSONValue
        );
      }
      const contactSocialType = configs.filter(config => config.name == 'Contacts Social Types')[0];
      if (contactSocialType?.configurationDetails.length > 0) {
        this.contactSocialTypes = JSON.parse(
          contactSocialType?.configurationDetails[0].configJSONValue
        );
      }
      this.getCustomFieldList();
    })
    this.appMainService.isHideSpinner("loadData");
  }

  async getCustomFieldList() {
    const purchaseObjId = this.app.preLoadedObjects.find(
      (el) => el.name == ObjectNames.purchaseConstants.Purchase_Module_Object)?.id;
    this.appMainService.isShowSpinner("loadData");
    this.productsService.getAllCustomFields(purchaseObjId).then((fields) => {
    this.appMainService.isHideSpinner("loadData");
      this.configCustomFields = fields;
      this.vendor_information = [];
      this.vendor_contact = [];
      this.vendor_address = [];
      this.vendor_business = [];
      this.vendor_payment = [];
      this.vendor_other1 = [];
      this.vendor_other2 = [];
      this.vendor_other3 = [];
      if (this.customFields && this.customFields.length > 0) {
        this.customFields.forEach((fld) => {
          if (fld.isDelete && fld.section?.name) {
            let check = false;
            switch (fld.section.code) {
              case "labels_vendor":
                check =
                  this.vendorTemplate?.labels_vendor?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (fld.formControl?.name == "FileUpload") {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "Picture") {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_vendor?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_information.push(fld);
                }
                break;
              case "labels_contact":
                check = this.vendorTemplate?.labels_contact?.find(
                  (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_contact?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_contact.push(fld);
                }
                break;
              case "labels_businessdetails":
                check =
                  this.vendorTemplate?.labels_businessdetails?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_businessdetails?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_business.push(fld);
                }
                break;
              case "labels_paymentdetails":
                check =
                  this.vendorTemplate?.labels_paymentdetails?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_paymentdetails?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_payment.push(fld);
                }
                break;
              case "labels_vendor_other1":
                check =
                  this.vendorTemplate?.labels_vendor_other1?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_vendor_other1?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_other1.push(fld);
                }
                break;
              case "labels_vendor_other2":
                check =
                  this.vendorTemplate?.labels_vendor_other2?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_vendor_other2?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_other2.push(fld);
                }
                break;
              case "labels_vendor_other3":
                check =
                  this.vendorTemplate?.labels_vendor_other3?.find(
                    (el) =>
                      el.code == fld.name &&
                      el.sectionId ==
                      fld.section?.id
                  )?.isChecked;
                if (check) {
                  fld.isChecked = check;
                  if (
                    fld.formControl?.name ==
                    "FileUpload"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (
                    fld.formControl?.name ==
                    "Picture"
                  ) {
                    fld.customUploadedFiles = [];
                  } else if (fld.formControl?.name == "ToggleButton") {
                    fld.value = false;
                  }
                  fld.labelname = this.vendorTemplate?.labels_vendor_other3?.find(
                    (el) => el.code == fld.name && el.sectionId == fld.section?.id)?.labelname;
                  this.vendor_other3.push(fld);
                }
                break;
              default:
                break;
            }
          }
        });
      }
      this.editVendor(this.selectedVendor,'view')
    });
  }
  




  checkRequired(name, cf_list) {
    return cf_list.find((el) => el.name === name)?.isRequired || false;
  }

  setTogleValue(field, event) {
    field.value = event.checked;
  }

  onCustomUpload(files: File[], field,instance) {
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
     
          }
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              name: name,
              content: content,
              extension: extension,
              sizeInBytes: size,
            };
            field.customUploadedFiles.push(attachment);
          });
        }
      }
      instance.clear();
    } else {

    }
  }

  deleteFile(field, index) {
    field.customUploadedFiles.splice(index, 1);
  }

  loadCustomRules() {
    this.purchaseService.getAllCustomRules().subscribe(rules => {
      this.vendorPayemntTermRule = rules.filter(rule => (rule.moduleName == 'Vendor' && rule.preferredPaymentTerm?.length > 0))[0];
      this.vendorPayemntMethodRule = rules.filter(rule => (rule.moduleName == 'Vendor' && rule.preferredPaymentMethod?.length > 0))[0];
    })
  }



  selectVendorTypes() {
    const vendorTypes = [];
    for (let type of this.vendorTypes) {
      if (type.name == 'Vendor') {
        vendorTypes.push(type.id)
      }
    }
    return vendorTypes;
  }
  isCurrencyChangeAllowed() {
    this.companyBranchService.validateCurrencyPermissions(this.savedVendor?.id, false).subscribe(resp => {
      if(resp){
        this.vendorForm.get('currencyId').disable();
      }
    });
  }

  editVendor(vendor, action) {
    if (action == 'edit') {
      this.vendorForm.enable();
      this.vendorHeader = 'Edit Vendor';
    } else {
      this.isView = true;
      this.vendorHeader = 'View Vendor';
      this.vendorForm.disable();
    }
    this.isAddVendor = false;
    this.savedVendor = vendor;
    this.allPaymentTermsDD = this.allPaymentTerms?.filter(term => term.statusId == 1);
    this.allPaymentMethodsDD = this.allPaymentMethods?.filter(method => method.statusId == 1);
    this.allShippingMethodDD = this.allShippingMethodDropdown?.filter(shipping => shipping.statusId == 1);
    this.vendorForm.patchValue(vendor);
    //Check for Inactive Payment Method records
    const res = this.savedVendor?.vendorPaymentMethod?.filter(x => !this.allPaymentMethodsDD?.some(y => y.id == x.paymentMethodId));
    if (res?.length > 0) {
      res.forEach(element => {
        this.allPaymentMethodsDD.push(element.paymentMethod);
      });
    }
    const filteredPaymentMethod = [];
    vendor.vendorPaymentMethod?.forEach(element => {
      const method = this.allPaymentMethodsDD?.filter(m => m?.id == element?.paymentMethodId)[0];
      filteredPaymentMethod.push(method);
    });
    this.vendorForm.controls['paymentMethodId'].setValue(filteredPaymentMethod);
    this.vendorForm.controls['preferredPaymentMethodId'].setValue(vendor.vendorPaymentMethod?.filter(m => m.isDefault == true).map(method => method.paymentMethodId)[0]);
    //Check for Inactive Payment Term records
    const res1 = this.savedVendor?.vendorPaymentTerm?.filter(x => !this.allPaymentTermsDD?.some(y => y.id == x.paymentTermId));
    if (res1?.length > 0) {
      res1.forEach(element => {
        this.allPaymentTermsDD.push(element.paymentTerm);
      });
    }
    const filteredPaymentTerm = [];
    vendor.vendorPaymentTerm?.forEach(element => {
      const method = this.allPaymentTermsDD?.filter(m => m?.id == element.paymentTermId)[0];
      filteredPaymentTerm.push(method);
    });
    this.vendorForm.controls['paymentTermId'].setValue(filteredPaymentTerm);
    this.vendorForm.controls['preferredPaymentTermId'].setValue(vendor.vendorPaymentTerm?.filter(m => m.isDefault == true).map(term => term.paymentTermId)[0]);
    //Check for Inactive Shipping Method records
    const res2 = this.savedVendor?.vendorShippingMethod?.filter(x => !this.allShippingMethodDD?.some(y => y.id == x.shippingMethodId));
    if (res2?.length > 0) {
      res2.forEach(element => {
        this.allShippingMethodDD.push(element.shippingMethod);
      });
    }
    const filteredShippingMethod = [];
    vendor.vendorShippingMethod?.forEach(element => {
      const method = this.allShippingMethodDD?.filter(m => m.id == element.shippingMethodId)[0];
      filteredShippingMethod.push(method)
    });
    this.vendorForm.controls['shippingMethodId'].setValue(filteredShippingMethod);
    this.vendorForm.controls['preferredShippingMethodId'].setValue(vendor.vendorShippingMethod?.filter(m => m.isDefault == true).map(method => method.shippingMethodId)[0]);
    const filteredVendorTypes = [];
    vendor.vendorTypes?.forEach(element => {
      filteredVendorTypes.push(element.typeId)
    });
    this.vendorForm.controls['vendorTypeId'].setValue(filteredVendorTypes);
    this.vendorForm.controls['emailAddress'].setValue(vendor.vendorEmails.length > 0 ? vendor.vendorEmails[0].email?.emailAddress : null);
    this.vendorForm.controls['phoneNumber'].setValue(vendor.vendorPhones.length > 0 ? vendor.vendorPhones[0].phone?.number : null);
    this.vendorForm.controls['statusId'].setValue(vendor.statusId == 1 ? true : false);
    if (vendor.vendorContacts.length > 0) {
      this.filteredContact = vendor.vendorContacts.filter(contact => contact.contact?.isPrimaryContact == true);
      this.reportsTo = vendor.vendorContacts.filter(contact => contact.contact?.isPrimaryContact == false);
      if (this.filteredContact.length > 0) {
        const filteredSalutation = this.salutations?.filter(s => s.id == this.filteredContact[0].contact?.salutationId)[0];
        this.vendorForm.controls['salutationId'].setValue(filteredSalutation);
        this.vendorForm.controls['firstName'].setValue(this.filteredContact[0].contact?.firstName);
        this.vendorForm.controls['isPrimaryContact'].setValue(this.filteredContact[0].contact?.isPrimaryContact);
        this.vendorForm.controls['lastName'].setValue(this.filteredContact[0].contact?.lastName);
        this.vendorForm.controls['dob'].setValue(new Date(this.filteredContact[0].contact?.dateOfBirth));
        this.vendorForm.controls['middleName'].setValue(this.filteredContact[0].contact?.middleName);
        this.vendorForm.controls['assistantPhone'].setValue(this.filteredContact[0].contact?.assistantPhone);
        const filteredGender = this.genders?.filter(gender => gender.id == this.filteredContact[0].contact?.genderId)[0];
        this.vendorForm.controls['genderId'].setValue(filteredGender);
        const filteredReportsTo = this.savedVendor.vendorContacts?.filter(contact => contact.contactId == this.filteredContact[0].contact?.reportsToId)[0];
        this.vendorForm.controls['reportsToId'].setValue(filteredReportsTo);
        const filteredAssistant = this.savedVendor.vendorContacts?.filter(contact => contact.contactId == this.filteredContact[0].contact?.assistantId)[0];
        this.vendorForm.controls['assistantId'].setValue(filteredAssistant);
        if (this.filteredContact[0].contact?.contactEmails.length > 0) {
          this.vendorForm.controls['contactEmail'].setValue(this.filteredContact[0].contact?.contactEmails[0].email.emailAddress);
        }
        if (this.filteredContact[0].contact?.contactSpokenLanguages.length > 0) {
          const filteredLanguages = [];
          this.filteredContact[0].contact?.contactSpokenLanguages.forEach(element => {
            const lang = this.languages.filter(lang => lang.id == element.languageId)[0];
            filteredLanguages.push(lang);
          });
          this.vendorForm.controls['languages'].setValue(filteredLanguages);
        }
        if (this.filteredContact[0].contact?.contactRoles.length > 0) {
          const filteredRoles = [];
          this.filteredContact[0].contact?.contactRoles.forEach(element => {
            const job = this.jobFunctions.filter(job => job.id == element.roleId)[0];
            filteredRoles.push(job);
          });
          this.vendorForm.controls['job'].setValue(filteredRoles);
        }
        if (this.filteredContact[0].contact?.contactPhones.length > 0) {
          this.vendorForm.controls['extension'].setValue(this.filteredContact[0].contact?.contactPhones[0].phone.extension);
          this.vendorForm.controls['contactPhone'].setValue(this.filteredContact[0].contact?.contactPhones[0].phone.number);
        }
        if (this.filteredContact[0].contact?.contactSocialProfiles.length > 0) {
          this.vendorForm.controls['socialProfile'].setValue(this.filteredContact[0].contact?.contactSocialProfiles[0].socialProfile.name);
        }
      }

    }
    vendor.vendorAddresses?.forEach(element => {
      const addressEach = {
        addressType: element.address?.addressType,
        formattedAddress: element.address?.streetAddress1,
        streetAddress2: element.address?.streetAddress2,
        countryId: element.address?.country,
        stateId: element.address?.state,
        cityId: element.address?.city,
        zipCode: element.address?.zipCode,
        statusId: (element.address?.statusId == 1 ? true : false),
        isDefault: element.address?.isDefault,
        lattitude: element.address?.lattitude,
        longitude: element.address?.longitude,
        attentionId: element.address?.attnContact,
        id: element.id,
        addressId: element.addressId,
        address: element.address
      }
      this.vendorTempAddress.push(addressEach);
    });
    //saved custom
    this.vendor_information.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_contact.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_business.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_payment.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_other1.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_other2.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.vendor_other3.forEach(element => {
      const filteredCustom = vendor.customAttributeValues?.filter(c => c.customAttributeId == element.id)[0];
      if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'InputBox' ||
      filteredCustom.customAttribute?.formControl?.name == 'Decimal' ||
      filteredCustom.customAttribute?.formControl?.name == 'Number')) {
        element.value = filteredCustom.value;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'FileUpload' || filteredCustom.customAttribute?.formControl?.name == 'Picture')) {
        element.customUploadedFiles = [];
        filteredCustom.customeAttachement.forEach(el => {
          element.customUploadedFiles.push(el);
        });
      }
      else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'DatePicker') {
        element.value = this.datepipe.transform(filteredCustom.value, 'MM/dd/yyyy');
      }
      else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'Rating')) {
        element.value = filteredCustom.ratingId;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'ToggleButton')) {
        element.value = filteredCustom.toggle;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'DropDownList')) {
        element.value = filteredCustom.values;
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'RadioButton') {
        element.value = filteredCustom.values.name;
      } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == 'CheckBox')) {
        element.value = [];
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el.name)
        });
      } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == 'MultipleDropDownList') {
        element.value = []
        filteredCustom.multipleValues.forEach(el => {
          element.value.push(el);
        });
      }
    });
    this.displayVendorAdd = true;
  }


  async editAddress(c, editAddIndex) {
    this.editAddressIndex = editAddIndex;
    this.addressHeader = "Edit Address";
    this.addressInput = c.formattedAddress;
    this.addressForm.patchValue(c);
    const filteredAddressType = this.addressTypes.filter(add => add.id == c.addressType?.id)[0];
    this.addressForm.controls['addressType'].setValue(filteredAddressType);

    const filteredCounry = this.country.filter(country => country.id == c.countryId?.id)[0];
    this.addressForm.controls['countryId'].setValue(filteredCounry);

    const filteredAttn = this.savedVendor?.vendorContacts?.filter(contact => contact.contactId == (this.isAddVendor ? c.attentionId?.contactId : c.attentionId?.id))[0];
    this.addressForm.controls['attentionId'].setValue(filteredAttn);
    if (c.countryId) {
      await this.getAsyncStatesFromCountry(c?.countryId);
    }
    if (c?.stateId) {
      await this.getAsyncCitiesFromState(c?.stateId);
    }
    const filteredState = this.states.filter(state => state.id == c.stateId?.id)[0];
    this.addressForm.controls['stateId'].setValue(filteredState);
    const filteredCity = this.city.filter(city => city.id == c.cityId?.id)[0];
    this.addressForm.controls['cityId'].setValue(filteredCity);
    this.addressForm.controls['statusId'].setValue(c.statusId == 1 ? true : false);
    this.addressForm.controls['isDefault'].setValue(c.isDefault == 1 ? true : false);
    this.displayAddressAdd = true;
  }

  setDefaultAddr(currentAdd, currentIndex) {
    if (this.vendorTempAddress.length > 1) {
      const addressType = this.vendorTempAddress[currentIndex].addressType;
      this.vendorTempAddress.forEach((addressObj, index) => {
        if (index !== currentIndex && addressType.id == addressObj.addressType.id) {
          addressObj.isDefault = false;
        }
      });
    } else {
      currentAdd.isDefault = true;
    }
    this.vendorTempAddress[currentIndex].statusId = true;
  }

  getContactName(addressObj) {
    let name = '';

    const attnContact = addressObj.attentionId;
    if (!attnContact?.contact) {
      if (attnContact && attnContact.firstName && attnContact.lastName) {
        name = attnContact.firstName + ' ' + attnContact.lastName;
      } else if (attnContact && attnContact.firstName) {
        name = attnContact.firstName
      } else if (attnContact && attnContact.lastName) {
        name = attnContact.lastName
      }
    } else {
      if (addressObj && addressObj?.attentionId?.contact?.firstName && addressObj?.attentionId?.contact?.lastName) {
        name = addressObj?.attentionId?.contact?.firstName + ' ' + addressObj?.attentionId?.contact?.lastName;
      } else if (addressObj?.attentionId?.contact?.firstName) {
        name = addressObj?.attentionId?.contact?.firstName
      } else if (addressObj?.attentionId?.contact?.lastName) {
        name = addressObj?.attentionId?.contact?.lastName
      }
    }
    return name;
  }

  getAllGroup() {
    this.purchaseService.getAllInventoryGroups().subscribe((res) => {
      const vendorTypeGroup = res.filter(group => group.name == 'Vendor Type')[0];
      this.getVendorTypes(vendorTypeGroup.id, 'vendor');
      const businessClassGroup = res.filter(group => group.name == 'Account Category')[0];
      this.getVendorTypes(businessClassGroup.id, 'business');
    });
  }

  getVendorTypes(id, type) {
    this.purchaseService.getVendorTypeList(id).subscribe((res) => {
      if (type == 'vendor')
        this.vendorTypes = res;
      else
        this.businessClass = res;
    });
  }

  loadTimezones() {
    this.purchaseService.getAllTimezone().subscribe((res) => {
      this.timeZoneList = res;
    });
  }

  loadAnnualIncome() {
    this.purchaseService.getAnnualRevenue().subscribe((res) => {
      this.annualRevenue = res;
    });
  }

  loadIndustry() {
    this.purchaseService.getIndustry().subscribe((res) => {
      this.industryList = res;
    });
  }

  loadOwners() {
    this.purchaseService.getOwnerShips().subscribe((res) => {
      this.owners = res;
    });
  }

  loadEmployeesCount() {
    this.purchaseService.getEmployeesCount().subscribe((res) => {
      this.employeesCount = res;
    });
  }

  loadCurrency() {
    this.purchaseService.getCurrency().subscribe((res) => {
      this.currencyList = res;
    });
  }

  addNewAddress() {
    this.editAddressIndex = null;
    this.addressInput = '';
    this.addressHeader = 'Add Address';
    this.addressForm = this.fb.group({
      id: [0],
      addressType: ['', [Validators.required]],
      address: [''],
      addressId: [0],
      formattedAddress: [''],
      streetAddress2: [''],
      lattitude: [''],
      longitude: [''],
      countryId: [''],
      stateId: [''],
      cityId: [''],
      zipCode: [''],
      attentionId: [''],
      statusId: [true],
      isDefault: [false]
    })
    this.displayAddressAdd = true;
  }

  deleteAddress() {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Addresss?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        // delete newly added record
        this.vendorTempAddress.splice(this.editAddressIndex, 1);
        this.displayAddressAdd = false;
      },
      reject: () => {
      }
    });


  }


  getAllCountry() {
    this.purchaseService.getCountry().subscribe((country) => {
      this.country = country;
    });
  }

  getStatesFromCountry(country) {
    const countryID = country.id;
    this.purchaseService.getAllStates(countryID).then((states) => {
      this.states = states;
    });
  }

  getCitiesFromState(state) {
    this.purchaseService.getAllCities(state.id).then((cities) => {
      this.city = cities;
    });
  }

  onAddressBlur(address) {
    this.addressInput = address;
    this.addressInput = '';
    if (address == '') {
      this.addressForm.controls['countryId'].reset();
      this.addressForm.controls['stateId'].reset();
      this.addressForm.controls['cityId'].reset();
      this.addressForm.controls['zipCode'].reset();
      this.addressInput = '';
    }
  }


  removeAddressLocation() {
    this.addressForm.controls['countryId'].reset();
    this.addressForm.controls['stateId'].reset();
    this.addressForm.controls['cityId'].reset();
    this.addressForm.controls['zipCode'].reset();
    this.addressInput = '';
  }

  getAddressObj(address) {
    const addressObj = {
      street_number: null,
      subpremise: null,
      plus_code: null,
      neighborhood: null,
      landmark: null,
      route: null,
      sublocality_level_3: null,
      sublocality_level_2: null,
      sublocality_level_1: null,
      locality: null,
      city: null,
      state: null,
      country: null,
      zipCode: null,
      latitude: address.geometry.location.lat(),
      longitude: address.geometry.location.lng(),
    }
    address.address_components.forEach(comp => {
      const field = comp.types[0];
      if (field == 'street_number') {
        addressObj.street_number = comp;
      }
      if (field == 'plus_code') {
        addressObj.plus_code = comp;
      }
      if (field == 'neighborhood') {
        addressObj.neighborhood = comp;
      }
      if (field == 'landmark') {
        addressObj.landmark = comp;
      }
      if (field == 'route') {
        addressObj.route = comp;
      }
      if (field == 'sublocality_level_3') {
        addressObj.sublocality_level_3 = comp;
      }
      if (field == 'sublocality_level_2') {
        addressObj.sublocality_level_2 = comp;
      }
      if (field == 'sublocality_level_1') {
        addressObj.sublocality_level_1 = comp;
      }
      if (field == 'subpremise') {
        addressObj.subpremise = comp;
      }
      // city
      if (field == 'locality') {
        addressObj.locality = comp;
        addressObj.city = comp;
      }
      // state
      if (field == 'administrative_area_level_1') {
        addressObj.state = comp;
      }

      if (field == 'country') {
        addressObj.country = comp;
      }
      if (field == 'postal_code') {
        addressObj.zipCode = comp;
      }
    });
    if (addressObj.city == null) {
      addressObj.city = addressObj.sublocality_level_1;
    }
    return addressObj;
  }

  getStreetAddres(googleAddressObj) {
    const street = [];
    if (googleAddressObj.plus_code) {
      street.push(googleAddressObj.plus_code.long_name);
    }
    if (googleAddressObj.street_number) {
      street.push(googleAddressObj.street_number.long_name);
    }
    if (googleAddressObj.route) {
      street.push(googleAddressObj.route.long_name);
    }
    if (googleAddressObj.subpremise) {
      street.push(`#${googleAddressObj.subpremise.long_name}`);
    }
    if (googleAddressObj.neighborhood) {
      street.push(googleAddressObj.neighborhood.long_name);
    }
    if (googleAddressObj.sublocality_level_3) {
      street.push(googleAddressObj.sublocality_level_3.long_name);
    }
    if (googleAddressObj.sublocality_level_2) {
      street.push(googleAddressObj.sublocality_level_2.long_name);
    }
    if (googleAddressObj.sublocality_level_1 && googleAddressObj.locality != null) {
      street.push(googleAddressObj.sublocality_level_1.long_name);
    }
    return street.length ? street.join(' ') : '';
  }


  async locationAddresChanged(address: any) {
    this.removeAddressLocation();
    //setting address from API to local variable
    this.ErrorMessageSetLocation = "";

    this.addressForm.controls['formattedAddress'].setValue(address.formatted_address);
    const googleAddressObj = this.getAddressObj(address);
    setTimeout(() => {
      const da = this.getStreetAddres(googleAddressObj); 
      this.addressInput = da;
      this.addressForm.controls['formattedAddress'].setValue(da);
    });



    this.addressForm.controls['lattitude'].setValue(googleAddressObj.latitude);
    this.addressForm.controls['longitude'].setValue(googleAddressObj.longitude);

    let searchedCountry = googleAddressObj.country ? googleAddressObj.country.long_name : '';
    let searchedZipcode = googleAddressObj.zipCode ? googleAddressObj.zipCode.long_name : '';
    let searchedState = googleAddressObj.state ? googleAddressObj.state.long_name : '';
    let searchedCity = googleAddressObj.city ? googleAddressObj.city.long_name : '';
    if (searchedCountry) {


      let matchedCountry;
      if (searchedCountry == 'USA' || searchedCountry == 'United States') {
        matchedCountry = this.country.find(obj => obj.name == searchedCountry || obj.countryCode == googleAddressObj.country.short_name);
      } else {
        matchedCountry = this.country.find(obj => obj.name == searchedCountry)
      }

      if (matchedCountry) {
        await this.getAsyncStatesFromCountry(matchedCountry);
        this.addressForm.controls['countryId'].setValue(matchedCountry);
        //set state
        let matchedState = this.states.find(obj => obj.name == searchedState || obj.shortName == googleAddressObj.state.short_name);
        if (matchedState) {
          this.addressForm.controls['stateId'].setValue(matchedState);
        } else if (!matchedState) {
          // add state
          matchedState = await this.addState(googleAddressObj.state, matchedCountry.id);
          this.addressForm.controls['stateId'].setValue(matchedState);
        }

        await this.getAsyncCitiesFromState(matchedState);

        if (searchedZipcode) {
          this.addressForm.controls['zipCode'].setValue(searchedZipcode);
        }
        //set city
        if(searchedCity){
          let matchedCity = this.city ? this.city.find(obj => obj.name == searchedCity) : null;
          if (matchedCity) {
            this.addressForm.controls['cityId'].setValue(matchedCity);
          } else if (!matchedCity) {
            matchedCity = await this.addCity(searchedCity, matchedState.id);
            this.addressForm.controls['cityId'].setValue(matchedCity);
          }
        }
      }
    }
  }

  async getAsyncStatesFromCountry(country) {
    let countryID = country.id;
    await this.purchaseService.getAllStates(countryID).then((states) => {
      this.states = states;
      this.addressForm.controls['stateId'].reset();
    });
  }

  async addCity(searchedCityName, stateId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: searchedCityName,
      description: searchedCityName,
      stateId: stateId,
      statusId: 1,
    }
    this.appMainService.isShowSpinner('addNewCity');
    const newAddedCity = await this.purchaseService.addCity(data)
    this.city = addInList(this.city, newAddedCity);
    this.appMainService.isHideSpinner('addNewCity');
    return newAddedCity;
  }


  async addState(stateDetails, countryId) {
    const data = {
      id: 0,
      createdSource: this.app.user.userIP,
      updatedSource: null,
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: null,
      name: stateDetails.long_name,
      shortName: stateDetails.short_name,
      description: stateDetails.long_name,
      countryId: countryId,
      statusId: 1,
    }
    this.appMainService.isShowSpinner('addNewState');
    const newAddedState = await this.purchaseService.addState(data);
    this.states = addInList(this.states, newAddedState);
    this.appMainService.isHideSpinner('addNewState');
    return newAddedState;
  }

  async getAsyncCitiesFromState(state) {
    await this.purchaseService.getAllCities(state.id).then((cities) => {
      this.city = cities;
      this.addressForm.controls['cityId'].reset();
    });
  }

  getAllAddressTypes() {
    this.purchaseService.getAddressTypes().subscribe((types) => {
      this.addressTypes = types;
      this.addressTypes.push({ id: 0, name: "Add New Type" })
    });
  }



  getEmailTypes() {
    this.purchaseService.getContactEmailTypes().subscribe((types) => {
      this.emailTypes = types;
    });
  }

  getPhoneTypes() {
    this.purchaseService.getContactPhoneTypes().subscribe((types) => {
      this.phoneTypes = types;
    });
  }

  getSocialProfileTypes() {
    this.purchaseService.getSocialProfileTypes().subscribe((types) => {
      this.socialProfileTypes = types;
    });
  }



  loadAssistant() {
    this.purchaseService.getAllAssistant(this.app.companyId).subscribe((assistant) => {
      this.assistant = assistant;
    });
  }

  getAddrType() {
    if (this.addressForm.controls['addressType'].value.name == 'Add New Type') {
      this.addressTypeForm = this.fb.group({
        id: [0],
        createdSource: [this.app.user.userIP],
        updatedSource: [this.app.user.userIP],
        createdBy: [this.app.user.userId],
        updatedBy: [this.app.user.userId],
        createdDate: [new Date().toISOString()],
        updatedDate: [new Date().toISOString()],
        name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
        parentTypeId: [0],
        description: [''],
        groupId: TypeGroupIds.AddressTypeCoreAPI,
        organizationId: [this.app.user.organizationId],
        colorCodeId: [0],
        statusId: [true]
      })
      this.displayAddAddressType = true;
    }
  }

  saveAddressType(value) {
    const addTypeExists = this.addressTypes.find(obj => obj.name.toLowerCase() == value.name.toLowerCase())
    if (addTypeExists) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Address type already added' });
    } else {
      this.purchaseService.addVendorAddressType(value).subscribe(res => {
        const addTypes = this.addressTypes;
        addTypes.splice(addTypes.length - 1, 0, res);
        this.addressTypes = JSON.parse(JSON.stringify(addTypes));
        this.displayAddAddressType = false;
      }, err => {

      });
    }
  }

  saveAddress(value) {
    if (this.editAddressIndex !== null) {
      this.vendorTempAddress.splice(this.editAddressIndex, 1, value);
      const defaultAddress = this.vendorTempAddress.filter(address => (address.addressType.id == value.addressType.id && address.isDefault == true));
      if (defaultAddress.length < 1) {
        value.isDefault = true;
      } else {
        value.isDefault = false;
      }
    } else {
      const defaultAddress = this.vendorTempAddress.filter(address => (address.addressType.id == value.addressType.id && address.isDefault == true));
      if (defaultAddress.length < 1) {
        value.isDefault = true;
      } else {
        value.isDefault = false;
      }
      this.vendorTempAddress.push(value);
    }
    this.displayAddressAdd = false;
  }

  setExistingVendorAddress() {
    const address = [];
    this.vendorTempAddress?.forEach(element => {
      const addressEach = {
        id: (element.id ? element.id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: this.savedVendor.id,
        addressId: (element.addressId ? element.addressId : 0),
        statusId: (element.statusId ? 1 : 2),
        address: {
          id: (element.address ? element.address.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          name: '',
          streetAddress1: element.formattedAddress,
          streetAddress2: element.streetAddress2,
          description: '',
          latitude: element.lattitude,
          longitude: element.longitude,
          isDefault: element.isDefault,
          cityId: (element.cityId ? element.cityId?.id : null),
          city: null,
          stateId: (element.stateId ? element.stateId?.id : null),
          state: null,
          countryId: (element.countryId ? element.countryId?.id : null),
          country: null,
          zipCode: element.zipCode,
          addressTypeId: element.addressType?.id,
          addressType: null,
          attnContactId: (element.attentionId?.contactId ? element.attentionId?.contactId : element.attentionId?.id ? element.attentionId?.id : null),
          attnContact: null,
          statusId: (element.statusId ? 1 : 2),
          status: null
        }
      }
      address.push(addressEach)
    });
    return address;
  }

  setVendorAddress() {
    const address = [];
    this.vendorTempAddress?.forEach(element => {
      const addressEach = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: 0,
        addressId: 0,
        statusId: (element.statusId ? 1 : 2),
        address: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          name: '',
          streetAddress1: element.formattedAddress,
          streetAddress2: element.streetAddress2,
          description: '',
          latitude: element.lattitude,
          longitude: element.longitude,
          isDefault: element.isDefault,
          cityId: (element.cityId ? element.cityId?.id : null),
          city: null,
          stateId: (element.stateId ? element.stateId?.id : null),
          state: null,
          countryId: (element.countryId ? element.countryId?.id : null),
          country: null,
          zipCode: element.zipCode,
          addressTypeId: element.addressType?.id,
          addressType: null,
          attnContactId: (element.attentionId ? element.attentionId.contactId : null),
          attnContact: null,
          statusId: (element.statusId ? 1 : 2),
          status: null
        }
      }
      address.push(addressEach)
    });
    return address;
  }

  setVendorEmail(value) {
    const email = [];
    if (value.emailAddress || value.contactEmail) {
      email.push({
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: 0,
        emailId: 0,
        email: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          emailAddress: (value.emailAddress ? value.emailAddress : value.contactEmail),
          description: (value.emailAddress ? value.emailAddress : value.contactEmail),
          emailTypeId: this.vendorEmailTypes.filter(associate => associate.name == 'Work Email').map(a => a.id)[0],
          emailType: null,
          statusId: (value.statusId ? 1 : 2),
          status: null
        }
      })
    }
    return email;
  }

  setExistingVendorEmail(value) {
    const email = [];
    if (value.emailAddress) {
      email.push({
        id: (this.savedVendor.vendorEmails?.length > 0 ? this.savedVendor.vendorEmails[0].id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: this.savedVendor.id,
        emailId: (this.savedVendor.vendorEmails?.length > 0 ? this.savedVendor.vendorEmails[0].emailId : 0),
        email: {
          id: (this.savedVendor.vendorEmails?.length > 0 ? this.savedVendor.vendorEmails[0].email?.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          emailAddress: value.emailAddress,
          description: value.emailAddress,
          emailTypeId: this.vendorEmailTypes?.filter(associate => associate.name == 'Work Email').map(a => a.id)[0],
          emailType: null,
          statusId: (value.statusId ? 1 : 2),
          status: null
        }
      })
    }
    return email;
  }

  setVendorPhone(value) {
    const phone = [];
    if (value.phoneNumber || value.contactPhone) {
      phone.push({
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: 0,
        phoneId: 0,
        phone: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          number: (value.phoneNumber ? value.phoneNumber : value.contactPhone),
          extension: '',
          description: (value.phoneNumber ? value.phoneNumber : value.contactPhone),
          phoneTypeId: this.vendorPhoneTypes.filter(associate => associate.name == 'Work').map(a => a.id)[0],
          phoneType: null,
          statusId: (value.statusId ? 1 : 2),
          status: null
        }
      })
    }
    return phone;
  }

  setContactEmail(value) {
    const contactEmail = [];
    if (value.contactEmail) {
      contactEmail.push({
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        contactId: 0,
        emailId: 0,
        email: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          emailAddress: value.contactEmail,
          description: value.contactEmail,
          emailTypeId: this.contactEmailTypes.filter(associate => associate.code == 'work').map(a => a.id)[0],
          statusId: (value.statusId ? 1 : 2)
        }
      })
    }
    return contactEmail;
  }

  setContactPhone(value) {
    const contactPhone = [];
    if (value.contactPhone) {
      contactPhone.push({
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        contactId: 0,
        phoneId: 0,
        phone: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          number: value.contactPhone,
          extension: value.extension,
          description: value.contactPhone,
          phoneTypeId: this.contactPhoneTypes.filter(associate => associate.code == 'work').map(a => a.id)[0],
          statusId: (value.statusId ? 1 : 2)
        }
      })
    }
    return contactPhone;
  }

  setContactSocial(value) {
    const social = [];
    if (value.socialProfile) {
      social.push({
        contactId: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.userId,
        createdDate: new Date().toISOString(),
        socialProfileId: 0,
        id: 0,
        updatedBy: this.app.userId,
        updatedDate: new Date().toISOString(),
        updatedSource: this.app.userIP,
        socialProfile: {
          name: value.socialProfile,
          description: '',
          createdSource: this.app.userIP,
          createdBy: this.app.userId,
          createdDate: new Date().toISOString(),
          socialProfileTypeId: this.contactSocialTypes.filter(profile => profile.code == 'website').map(a => a.id)[0],
          id: 0,
          statusId: (value.statusId ? 1 : 2),
          updatedBy: this.app.userId,
          updatedDate: new Date().toISOString(),
          updatedSource: this.app.userIP
        }
      })
    }
    return social;
  }

  setContactRoles(value) {
    const roles = [];
    if (value?.length > 0) {
      value.forEach(element => {
        const roleEach = {
          contactId: 0,
          createdSource: this.app.userIP,
          createdBy: this.app.userId,
          createdDate: new Date().toISOString(),
          roleId: element.id,
          statusId: 1,
          id: 0,
          updatedBy: this.app.userId,
          updatedDate: new Date().toISOString(),
          updatedSource: this.app.userIP,
        }
        roles.push(roleEach);
      });
    }
    return roles;
  }

  setExistingContactRoles(value) {
    const roles = [];
    if (value?.length > 0) {
      value.forEach(element => {
        const roleEach = {
          contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
          createdSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          createdDate: new Date().toISOString(),
          roleId: element.id,
          statusId: 1,
          id: 0,
          updatedBy: this.app.userId,
          updatedDate: new Date().toISOString(),
          updatedSource: this.app.userIP,
        }
        roles.push(roleEach);
      });
    }
    return roles;
  }

  setVendorContact(value) {
    const contact = [];
    if (value.firstName) {
      contact.push({
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: 0,
        contactId: 0,
        statusId: (value.statusId ? 1 : 2),
        contact: {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          salutationId: (value.salutationId ? value.salutationId.id : null),
          salutation: null,
          name: (value.firstName + " " + value.lastName),
          firstName: value.firstName,
          middleName: value.middleName,
          lastName: value.lastName,
          title: value.title,
          dateOfBirth: value.dob,
          sourceId: null,
          isPrimaryContact: value.isPrimaryContact,
          description: '',
          contactAssociationTypeId: this.associationTypes?.filter(associate => associate.name == 'Vendor').map(a => a.id)[0],
          associationName: value.vendorName,
          associationId: 0,
          genderId: (value.genderId ? value.genderId.id : null),
          degreeId: null,
          fieldOfStudyId: null,
          contactTypeId: null,
          relationshipStatusId: null,
          maritalStatusId: null,
          annualIncomeId: null,
          startDate: '',
          jobFunction: '',
          department: null,
          seniority: null,
          reportsToId: (value.reportsToId ? value.reportsToId.contactId : null),
          assistantId: (value.assistantId ? value.assistantId.contactId : null),
          assistantPhone: value.fassistantPhone,
          organizationId: this.app.companyId,
          statusId: (value.statusId ? 1 : 2),
          contactEmails: this.setContactEmail(value),
          contactPhones: this.setContactPhone(value),
          contactSocialProfiles: this.setContactSocial(value),
          contactSpokenLanguagesId: 0,
          contactSpokenLanguages: this.setContactLanguage(value.languages),
          contactRoles: this.setContactRoles(value.job)
        }
      })
    }
    return contact;
  }

  setContactLanguage(value) {
    const lang = [];
    if (value?.length > 0) {
      value.forEach(element => {
        const req = {
          contactId: 0,
          languageId: element.id,
          language: {
            name: element.name,
            description: element.name,
            statusId: 1,
            status: null,
            isValid: true,
            validFromDate: new Date().toISOString(),
            validToDate: new Date(),
            id: element.id,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.app.userId,
            updatedBy: this.app.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString()
          },
          statusId: 1,
          status: null,
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString()
        }
        lang.push(req)
      });
    }
    return lang;
  }

  setExistingContactLanguage(value) {
    const lang = [];
    if (value?.length > 0) {
      value.forEach(element => {
        const req = {
          contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
          languageId: element.id,
          language: {
            name: element.name,
            description: element.name,
            statusId: 1,
            status: null,
            isValid: true,
            validFromDate: new Date().toISOString(),
            validToDate: new Date(),
            id: element.id,
            createdSource: this.app.userIP,
            updatedSource: this.app.userIP,
            createdBy: this.savedVendor?.createdBy,
            updatedBy: this.app.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString()
          },
          statusId: 1,
          status: null,
          id: (this.filteredContact?.length > 0 ? this.filteredContact[0].contact?.contactSpokenLanguages?.filter(lang =>
            lang.languageId == element.id).map(langs => langs.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString()
        }
        lang.push(req)
      });
    }
    return lang;
  }

  setExistingContactEmail(value) {
    const contactEmail = [];
    if (value.contactEmail) {
      contactEmail.push({
        id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactEmails?.length > 0 ? this.filteredContact[0].contact?.contactEmails[0].id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
        emailId: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactEmails?.length > 0 ? this.filteredContact[0].contact?.contactEmails[0].emailId : 0),
        email: {
          id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactEmails?.length > 0 ? this.filteredContact[0].contact?.contactEmails[0].email?.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          emailAddress: value.contactEmail,
          description: value.contactEmail,
          emailTypeId: this.contactEmailTypes?.filter(associate => associate.code == 'work').map(a => a.id)[0],
          statusId: (value.statusId ? 1 : 2)
        }
      })
    }
    return contactEmail;
  }

  setExistingContactPhone(value) {
    const contactPhone = [];
    if (value.contactPhone) {
      contactPhone.push({
        id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactPhones?.length > 0 ? this.filteredContact[0].contact.contactPhones[0].id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
        phoneId: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactPhones?.length > 0 ? this.filteredContact[0].contact?.contactPhones[0].phoneId : 0),
        phone: {
          id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactPhones?.length > 0 ? this.filteredContact[0].contact?.contactPhones[0].phone?.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          number: value.contactPhone,
          extension: value.extension,
          description: value.contactPhone,
          phoneTypeId: this.contactPhoneTypes?.filter(associate => associate.code == 'work').map(a => a.id)[0],
          statusId: (value.statusId ? 1 : 2)
        }
      })
    }
    return contactPhone;
  }

  setExistingContactSocial(value) {
    const social = [];
    if (value.socialProfile) {
      social.push({
        contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
        createdSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        createdDate: new Date().toISOString(),
        socialProfileId: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactSocialProfiles?.length > 0 ? this.filteredContact[0].contact?.contactSocialProfiles[0].socialProfileId : 0),
        id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactSocialProfiles?.length > 0 ? this.filteredContact[0].contact?.contactSocialProfiles[0].id : 0),
        updatedBy: this.app.userId,
        updatedDate: new Date().toISOString(),
        updatedSource: this.app.userIP,
        socialProfile: {
          name: value.socialProfile,
          description: '',
          createdSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          createdDate: new Date().toISOString(),
          socialProfileTypeId: this.contactSocialTypes?.filter(profile => profile.name == 'Website').map(a => a.id)[0],
          id: (this.filteredContact?.length > 0 && this.filteredContact[0].contact?.contactSocialProfiles?.length > 0 ? this.filteredContact[0].contact?.contactSocialProfiles[0].socialProfile?.id : 0),
          statusId: (value.statusId ? 1 : 2),
          updatedBy: this.app.userId,
          updatedDate: new Date().toISOString(),
          updatedSource: this.app.userIP
        }
      })
    }
    return social;
  }

  setExistingVendorContact(value) {
    const contact = [];
    if (value.firstName) {
      contact.push({
        id: (this.filteredContact?.length > 0 ? this.filteredContact[0].id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: this.savedVendor.id,
        statusId: (value.statusId ? 1 : 2),
        contactId: (this.filteredContact?.length > 0 ? this.filteredContact[0].contactId : 0),
        contact: {
          id: (this.filteredContact?.length > 0 ? this.filteredContact[0].contact?.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          salutationId: (value.salutationId ? value.salutationId.id : null),
          salutation: null,
          name: (value.firstName + " " + value.lastName),
          firstName: value.firstName,
          middleName: value.middleName,
          lastName: value.lastName,
          title: value.title,
          dateOfBirth: value.dob,
          sourceId: null,
          isPrimaryContact: value.isPrimaryContact,
          description: '',
          contactAssociationTypeId: this.associationTypes?.filter(associate => associate.name == 'Vendor').map(a => a.id)[0],
          associationName: (value.vendorName),
          associationId: (this.savedVendor?.id),
          genderId: (value.genderId ? value.genderId.id : null),
          degreeId: null,
          fieldOfStudyId: null,
          contactTypeId: null,
          relationshipStatusId: null,
          maritalStatusId: null,
          annualIncomeId: null,
          startDate: '',
          jobFunction: '',
          department: null,
          seniority: null,
          reportsToId: (value.reportsToId ? value.reportsToId.contactId : null),
          assistantPhone: value.assistantPhone,
          assistantId: (value.assistantId ? value.assistantId.contactId : null),
          organizationId: this.app.companyId,
          statusId: (value.statusId ? 1 : 2),
          contactEmails: this.setExistingContactEmail(value),
          contactPhones: this.setExistingContactPhone(value),
          contactSocialProfiles: this.setExistingContactSocial(value),
          contactSpokenLanguagesId: 0,
          contactSpokenLanguages: this.setExistingContactLanguage(value.languages),
          contactRoles: this.setExistingContactRoles(value.job)
        }
      })
    }
    if (this.savedVendor?.vendorContacts?.length > 1) {
      this.savedVendor?.vendorContacts.forEach(element => {
        if (element.contact.isPrimaryContact == false) {
          contact.push(element)
        }
      });
    }
    return contact;
  }

  setExistingVendorPhone(value) {
    const phone = [];
    if (value.phoneNumber) {
      phone.push({
        id: (this.savedVendor.vendorPhones?.length > 0 ? this.savedVendor.vendorPhones[0].id : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: this.savedVendor.id,
        statusId: (value.statusId ? 1 : 2),
        phoneId: (this.savedVendor.vendorPhones?.length > 0 ? this.savedVendor.vendorPhones[0].phoneId : 0),
        phone: {
          id: (this.savedVendor.vendorPhones?.length > 0 ? this.savedVendor.vendorPhones[0].phone.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          number: value.phoneNumber,
          extension: '',
          description: value.phoneNumber,
          phoneTypeId: this.vendorPhoneTypes?.filter(associate => associate.name == 'Work').map(a => a.id)[0],
          phoneType: null,
          statusId: (value.statusId ? 1 : 2),
          status: null
        }
      })
    }
    return phone;
  }

  checkCustomValidation() {
    const requiredFields = [];
    this.vendor_information.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_contact.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_business.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_payment.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_other1.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_other2.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    this.vendor_other3.forEach(element => {
      if (element.isRequired) {
        requiredFields.push(element);
      }
    });
    const nullValue = [];
    requiredFields.forEach(element => {
      if ((element.formControl.name == 'fileUpload' || element.formControl.name == 'Picture') && element.customUploadedFiles.length == 0) {
        nullValue.push(element);
      }
    });
    requiredFields.forEach(element => {
      if ((element.formControl.name != 'FileUpload' && element.formControl.name != 'Picture' && element.formControl.name != 'ToggleButton') && (element.value == null || element.value == '')) {
        nullValue.push(element);
      }
    });
    if (nullValue.length > 0) {
      return true;
    } else {
      return false
    }
  }


  setCheckBoxValue(value) {
    const checkBox = [];
    value.forEach((element) => {
      const val = { name: element };
      checkBox.push(val);
    });
    return checkBox;
  }

  modifyCustomAttributes(data) {
    const customAttributeData = JSON.parse(JSON.stringify(data));
    if (customAttributeData.pickListValues) {
      customAttributeData.pickListValues = JSON.stringify(customAttributeData.pickListValues);
    }
    return customAttributeData;
  }

  setCustomAttributes(value) {
    const custom = [];
    if (value.length > 0) {
      value.forEach((element) => {
        const customEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          objectId: this.purchaseObjId,
          objectValue: 0,
          customAttributeId: element.id,
          customAttribute: this.modifyCustomAttributes(element),
          value:
            element.formControl?.name == "InputBox" ||
              element.formControl?.name == "DatePicker" || element.formControl?.name == "Decimal" ||
              element.formControl?.name == "Number"
              ? element.value
              : null,
          statusId: 1,
          status: null,
          values:
            element.formControl?.name == "DropDownList"
              ? element.value
              : element.formControl?.name == "RadioButton"
                ? { name: element.value }
                : null,
          multipleValues:
            element.formControl?.name == "MultipleDropDownList"
              ? element.value
              : element.formControl?.name == "CheckBox"
                ? this.setCheckBoxValue(element.value)
                : null,
          ratingId:
            element.formControl?.name == "Rating"
              ? element.value
              : 0,
          toggle:
            element.formControl?.name == "ToggleButton"
              ? element.value
              : false,
          customeAttachement:
            element.formControl?.name == "FileUpload" ||
              element.formControl?.name == "Picture"
              ? element.customUploadedFiles
              : null,
        };
        custom.push(customEach);
      });
    }
    return custom;
  }

  setExistingCustomAttributes(value) {
    const custom = [];
    if (value.length > 0) {
      value.forEach((element) => {
        const customEach = {
          id: (this.savedVendor.customAttributeValues?.filter(custom => custom.customAttributeId == element.id)[0] ? this.savedVendor.customAttributeValues?.filter(custom => custom.customAttributeId == element.id)[0]?.id : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          objectId: this.purchaseObjId,
          objectValue: this.savedVendor.id,
          customAttributeId: element.id,
          customAttribute: this.modifyCustomAttributes(element),
          value: (element.formControl?.name == "InputBox" || element.formControl?.name == "DatePicker" ||
           element.formControl?.name == "Decimal" || element.formControl?.name == "Number") ? element.value : null,
          statusId: 1,
          status: null,
          values: element.formControl?.name == "DropDownList" ? element.value : element.formControl?.name == "RadioButton" ? { name: element.value } : null,
          multipleValues: element.formControl?.name == "MultipleDropDownList" ? element.value : element.formControl?.name == "CheckBox" ? this.setCheckBoxValue(element.value) : null,
          ratingId: element.formControl?.name == "Rating" ? element.value : 0,
          toggle: element.formControl?.name == "ToggleButton" ? element.value : false,
          customeAttachement: (element.formControl?.name == "FileUpload" || element.formControl?.name == "Picture") ? element.customUploadedFiles : null,
        };
        custom.push(customEach);
      });
    }
    const deletedCustom = this.savedVendor.customAttributeValues?.filter(val1 => !value.some(val2 => val1.customAttributeId == val2.id));
    if (deletedCustom?.length > 0) {
      deletedCustom.forEach(element => {
        element.statusId = 3;
        custom.push(element)
      });
    }
    return custom;
  }

  setPaymentMethod(value) {
    const methods = [];
    if (value.paymentMethodId?.length > 0) {
      value.paymentMethodId.forEach(element => {
        const methodEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: 0,
          paymentMethodId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredPaymentMethodId ? true : false)
        }
        methods.push(methodEach);
      });
    }
    return methods;
  }

  setExistingPaymentMethod(value) {
    const methods = [];
    if (value.paymentMethodId?.length > 0) {
      value.paymentMethodId.forEach(element => {
        const methodEach = {
          id: (this.savedVendor?.vendorPaymentMethod?.filter(m => m.paymentMethodId == element.id)[0] ?
            this.savedVendor?.vendorPaymentMethod?.filter(m => m.paymentMethodId == element.id).map(m => m.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: this.savedVendor?.id,
          paymentMethodId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredPaymentMethodId ? true : false)
        }
        methods.push(methodEach);
      });
    }
    return methods;
  }

  setPaymentTerm(value) {
    const terms = [];
    if (value.paymentTermId?.length > 0) {
      value.paymentTermId.forEach(element => {
        const termEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: 0,
          paymentTermId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredPaymentTermId ? true : false)
        }
        terms.push(termEach);
      });
    }
    return terms;
  }

  setExistingPaymentTerm(value) {
    const terms = [];
    if (value.paymentTermId?.length > 0) {
      value.paymentTermId.forEach(element => {
        const termEach = {
          id: (this.savedVendor?.vendorPaymentTerm?.filter(m => m.paymentTermId == element.id)[0] ?
            this.savedVendor?.vendorPaymentTerm?.filter(m => m.paymentTermId == element.id).map(m => m.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: this.savedVendor?.id,
          paymentTermId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredPaymentTermId ? true : false)
        }
        terms.push(termEach);
      });
    }
    return terms;
  }

  setShippingMethod(value) {
    const methods = [];
    if (value.shippingMethodId?.length > 0) {
      value.shippingMethodId.forEach(element => {
        const methodEach = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: 0,
          shippingMethodId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredShippingMethodId ? true : false)
        }
        methods.push(methodEach);
      });
    }
    return methods;
  }

  setExistingShippingMethod(value) {
    const methods = [];
    if (value.shippingMethodId?.length > 0) {
      value.shippingMethodId.forEach(element => {
        const methodEach = {
          id: (this.savedVendor?.vendorShippingMethod?.filter(m => m.shippingMethodId == element.id)[0] ?
            this.savedVendor?.vendorShippingMethod?.filter(m => m.shippingMethodId == element.id).map(m => m.id)[0] : 0),
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorId: this.savedVendor?.id,
          shippingMethodId: element.id,
          statusId: 1,
          isDefault: (element.id == value.preferredShippingMethodId ? true : false)
        }
        methods.push(methodEach);
      });
    }
    return methods;
  }

  setVendorTypes(value) {
    const types = [];
    value.vendorTypeId?.forEach(element => {
      const typeEach = {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.userId,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: 0,
        typeId: element,
        type: null,
        statusId: (value.statusId ? 1 : 2),
        status: null
      }
      types.push(typeEach);
    });
    return types;
  }

  setExistingVendorTypes(value) {
    const types = [];
    value.vendorTypeId?.forEach(element => {
      const typeEach = {
        id: (this.savedVendor.vendorTypes?.filter(type => type.typeId == element)[0] ? (this.savedVendor.vendorTypes?.filter(type => type.typeId == element).map(t => t.id)[0]) : 0),
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.savedVendor?.createdBy,
        updatedBy: this.app.userId,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        vendorId: this.savedVendor.id,
        typeId: element,
        type: null,
        statusId: (value.statusId ? 1 : 2),
        status: null
      }
      types.push(typeEach);
    });
    return types;
  }

  save(value) {
    this.isDisabled = true;
    this.applyValidation = false;
    if ((this.isAddVendor || value.statusId) ? this.checkCustomValidation() : false) {
      this.applyValidation = true;
      this.isDisabled = false;
    } else {
      const customattributeList = [];
      if (this.vendor_information.length > 0) {
        this.vendor_information.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_contact.length > 0) {
        this.vendor_contact.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_business.length > 0) {
        this.vendor_business.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_payment.length > 0) {
        this.vendor_payment.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_other1.length > 0) {
        this.vendor_other1.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_other2.length > 0) {
        this.vendor_other2.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.vendor_other3.length > 0) {
        this.vendor_other3.forEach((element) => {
          if (
            (element.formControl.name == "FileUpload" ||
              element.formControl.name == "Picture") &&
            element.customUploadedFiles.length > 0
          ) {
            customattributeList.push(element);
          } else if (element.value) {
            customattributeList.push(element);
          }
        });
      }
      if (this.isAddVendor) {
        const req = {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorName: value.vendorName,
          vendorNumber: '',
          accountNumber: value.accountNumber,
          doingBusinessAs: value.doingBusinessAs,
          organizationId: this.app.companyId,
          description: '',
          taxId: value.taxId,
          businessClassificationId: (value.businessClassificationId ? value.businessClassificationId : 0),
          sicCode: value.sicCode,
          naicsCode: value.naicsCode,
          industryId: (value.industryId ? value.industryId : 0),
          industry: null,
          foundedYear: value.foundedYear,
          ownershipId: (value.ownershipId ? value.ownershipId : 0),
          ownership: null,
          employeesRangeId: (value.employeesRangeId ? value.employeesRangeId : 0),
          employeesRange: null,
          annualRevenueId: (value.annualRevenueId ? value.annualRevenueId : 0),
          annualRevenue: null,
          paymentTermId: 0,
          paymentMethodId: 0,
          shippingMethodId: 0,
          vendorPaymentMethod: this.setPaymentMethod(value),
          vendorPaymentTerm: this.setPaymentTerm(value),
          vendorShippingMethod: this.setShippingMethod(value),
          vendorShippingTerm: [],
          phoneNumber: '',
          emailAddress: '',
          websiteURL: '',
          facebookPage: '',
          linkedinPage: '',
          twitterPage: '',
          instagramPage: '',
          statusId: (value.statusId ? 1 : 2),
          status: null,
          vendorStatusId: (value.statusId ? 1 : 2),
          isValid: true,
          validFrom: new Date().toISOString(),
          validTo: new Date().toISOString(),
          timeZoneId: (value.timeZoneId ? value.timeZoneId : 0),
          timeZone: null,
          currencyId: (value.currencyId ? value.currencyId : 0),
          currencyUnit: null,
          vendorAddresses: this.setVendorAddress(),
          vendorContacts: this.setVendorContact(value),
          vendorEmails: this.setVendorEmail(value),
          vendorPhones: this.setVendorPhone(value),
          vendorTypes: this.setVendorTypes(value),
          customAttributeValues: this.setCustomAttributes(customattributeList)
        }
        this.appMainService.isShowSpinner("loadDetails");

        this.purchaseService.addVendor(req).then(() => {
          
          this.displayVendorAdd = false;
          this.isDisabled = false;
          this.purchaseService.setVendorList('add');
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Vendor added successfully..." });
          this.appMainService.isHideSpinner('loadDetails');
          this.closeDialog.emit(true);
        })
          .catch(() => {
           this.appMainService.isHideSpinner('loadDetails');
            this.isDisabled = false;
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
          });
      } else {
        const req = {
          id: this.savedVendor.id,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.savedVendor?.createdBy,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          vendorName: value.vendorName,
          vendorNumber: this.savedVendor.vendorNumber,
          accountNumber: value.accountNumber,
          doingBusinessAs: value.doingBusinessAs,
          organizationId: this.app.companyId,
          description: '',
          taxId: value.taxId,
          businessClassificationId: (value.businessClassificationId ? value.businessClassificationId : 0),
          sicCode: value.sicCode,
          naicsCode: value.naicsCode,
          industryId: (value.industryId ? value.industryId : 0),
          industry: null,
          foundedYear: value.foundedYear,
          ownershipId: (value.ownershipId ? value.ownershipId : 0),
          ownership: null,
          employeesRangeId: (value.employeesRangeId ? value.employeesRangeId : 0),
          employeesRange: null,
          annualRevenueId: (value.annualRevenueId ? value.annualRevenueId : 0),
          annualRevenue: null,
          paymentTermId: 0,
          paymentMethodId: 0,
          shippingMethodId: 0,
          vendorPaymentMethod: this.setExistingPaymentMethod(value),
          vendorPaymentTerm: this.setExistingPaymentTerm(value),
          vendorShippingMethod: this.setExistingShippingMethod(value),
          phoneNumber: '',
          emailAddress: '',
          websiteURL: '',
          facebookPage: '',
          linkedinPage: '',
          twitterPage: '',
          instagramPage: '',
          statusId: (value.statusId ? 1 : 2),
          status: null,
          vendorStatusId: (value.statusId ? 1 : 2),
          isValid: true,
          validFrom: new Date().toISOString(),
          validTo: new Date().toISOString(),
          timeZoneId: (value.timeZoneId ? value.timeZoneId : 0),
          timeZone: null,
          currencyId: (value.currencyId ? value.currencyId : 0),
          currencyUnit: null,
          vendorAddresses: this.setExistingVendorAddress(),
          vendorContacts: this.setExistingVendorContact(value),
          vendorEmails: this.setExistingVendorEmail(value),
          vendorPhones: this.setExistingVendorPhone(value),
          vendorTypes: this.setExistingVendorTypes(value),
          customAttributeValues: this.setExistingCustomAttributes(customattributeList)
        }
        this.appMainService.isShowSpinner("saveVendor");
        this.purchaseService.updateVendor(req).then(() => {
        this.appMainService.isHideSpinner("saveVendor");
          this.displayVendorAdd = false;
          this.isDisabled = false;
          this.purchaseService.setVendorList('update');
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: "Vendor updated successfully..." });
          this.closeDialog.emit(false);
        })
          .catch(() => {
           this.appMainService.isHideSpinner("saveVendor");
            this.isDisabled = false;
            this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: "Error in saving data..." });
          });
      }
    }
  }

  enableVendorForm() {
    this.vendorHeader = 'Edit Vendor';
    this.vendorForm.enable();
    this.isCurrencyChangeAllowed()
    this.isView = false;
  }

  resetDialog() {
    this.vendorForm.enable();
    if (this.customFields && this.customFields.length > 0) {
      this.customFields.forEach((fld) => {
        if (fld.formControl.name == 'FileUpload' || fld.formControl?.name == 'Picture') {
          fld.customUploadedFiles = [];
        } else if (fld.formControl.name == 'ToggleButton') {
          fld.value = false;
        } else {
          fld.value = null;
        }
      });
    }
    this.applyValidation = false;
    this.vendorForm.reset();
    this.isView = false;
    this.vendorTempAddress = [];
    this.filteredContact = [];
  }

  cancelVendorDialog(){
    this.displayVendorAdd = false
    this.closeDialog.emit(false);
  }

}
